
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class LiveWebinarsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${LiveWebinarsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events/{eventId}/locationdatetimes/{locationDateTimeId}/livewebinars';

    public addHost(eventId: string, locationDateTimeId: string): Observable<SuccessResponse<string> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<string>>(LiveWebinarsService.URL.replace('{eventId}', eventId).replace('{locationDateTimeId}', locationDateTimeId) + '/addhosts', {}).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
